import { Navigate } from '@sorare/routing';

import { ANY_SPORT_MARKET_SHOP_AUCTIONS } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const PrimaryMarket = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate to={generateSportContextPath(ANY_SPORT_MARKET_SHOP_AUCTIONS)} />
  );
};

export default PrimaryMarket;
